import "../styles/About.css";
import me from "../images/me2026.png";

function about() {
    return (
        <div className="about">
            <p> Ryan Boughton-Shields launched Boughton-Shields Creations in 2022 to share his projects with the world. He was diagnosed Autistic in 2019 and has many special interests due to this. These include but are not limited to Photography, music and all things tech. This website showcases the projects he creates, experiences with Autism and other maybe some other random things he just felt like sharing and writing about. </p>
            <img src = {me} alt="Black and White Portrait of Ryan Boughton-Shields" class="center" id="selfPortrait"/>  
        </div>
    )
}

export default about;